import { useTranslation } from 'react-i18next';

import { useRootSelector } from '../../../../store/hooks';
import { selectSiteHeader } from '../../../../store/features/siteHeader';
import { BookingFormType, SiteTypes } from '../../../../types';
import { selectPageConfig } from '../../../../store/features/pageConfig';

export default function useGetBookingCustomButtonData() {
  const { t } = useTranslation();
  const {
    data: { bookingForm, registrationName },
  } = useRootSelector(selectSiteHeader);
  const { siteType } = useRootSelector(selectPageConfig);
  const isCustomButton =
    bookingForm?.bookingFormType === BookingFormType.CUSTOM;

  let customLabel = isCustomButton ? bookingForm?.buttonText : undefined;
  const customUrl = isCustomButton ? bookingForm?.customBookingUrl : undefined;

  if (siteType === SiteTypes.COURSE && !isCustomButton) {
    customLabel = t(`site.pricing.book-now.${registrationName}`);
  }

  return { customLabel, customUrl };
}
